import { buildQrCodeUrl } from './walletAddressConstants';

export default function AddressQrCode({ value, size = 80, alt = '地址二維碼' }) {
  if (!value) {
    return <span className="wallet-address-qr-empty">—</span>;
  }
  return (
    <img
      className="wallet-address-qr"
      src={buildQrCodeUrl(value, size)}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
    />
  );
}
